import angular from 'angular';
import { socialServiceFactory } from './socialService.factory';
import { artistServiceModule } from '../../../shared/services/artistService/artistService.module';

export const socialServiceModule = angular
  .module('bit.services.socialService', [artistServiceModule.name])
  .factory('socialService', socialServiceFactory);
